'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  BLOCKED_USERS_QUERY_KEY,
  FRIENDS_QUERY_KEY,
  FRIENDS_TAB_COUNTS_QUERY_KEY,
  RECEIVED_REQUESTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { unblockUser } from '@/utils/actions/players/friends/unblockUser';

export interface UseUnblockUserParams {
  uuid: string;
  blockedUuid: string;
}

export const useUnblockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, blockedUuid }: UseUnblockUserParams) => {
      const res = await unblockUser({ uuid, blockedUuid });
      if (res.error) {
        throw new Error(`Failed to unblock user: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRIENDS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RECEIVED_REQUESTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [BLOCKED_USERS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
